import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'medpt-radio',
    templateUrl: './radio.component.html',
    standalone: false
})
export class RadioComponent {
  @Input() field: any = {};
  @Input() form!: FormGroup;

  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  constructor() {

  }
}



